/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { FlatSubtenant } from '@/client';
import { useTheme } from '@/hooks/useTheme';
import { Avatar } from '@/primitives/Avatar';
import { Text } from '@/primitives/Text';
import { useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';
import { tokens } from '@/theme';

import './SubtenantSwitcherSelectedSubtenant.css';

export type SubtenantSwitcherSelectedSubtenantProps = {
  selectedSubtenant?: FlatSubtenant;
  setShowInput: (showInput: boolean) => void;
};

export function SubtenantSwitcherSelectedSubtenant({
  selectedSubtenant,
  setShowInput,
}: SubtenantSwitcherSelectedSubtenantProps) {
  const theme = useTheme();
  const dark = useMgmtPlaneStateStore((state) => state.darkMode);
  const selectedTenantName = useMgmtPlaneStateStore((state) => state.selectedTenantName);
  const subtenantNameClassName = dark ? 'name-dark' : 'name-light';

  const color = { color: theme.antdComponents?.Menu?.itemColor };

  // Use subtenant name if available, otherwise use tenant name as fallback
  const displayName = selectedSubtenant?.name || selectedTenantName || 'Tenant';
  const avatarText = selectedSubtenant?.name?.[0]?.toUpperCase() || selectedTenantName?.[0]?.toUpperCase() || 'T';

  return (
    <section className="subtenant-switcher-selected-subtenant">
      <span
        className={`subtenant-switcher-selected-subtenant-name ${subtenantNameClassName}`}
        data-testid={`subtenant-option-${selectedSubtenant?.id}`}
      >
        <button type="button" onClick={() => setShowInput(true)}>
          <Avatar
            size="xxs"
            text={avatarText}
            color={tokens.color.gold.gold03}
            backgroundColor={tokens.color.text.textSubtle}
            dataTestId="subtenant-avatar"
            shape="square"
          />
          <span>
            <Text data-testid="subtenant-name-visible" style={color} ellipsis>
              {displayName}
            </Text>
          </span>
        </button>
      </span>
    </section>
  );
}
